exports.install = function (Vue, options) {
	Vue.prototype.api.Antenna = {
		read(value)//获取设备天线单条数据
		{
			return Vue.prototype.axiosget("/api/rf/Antenna/read",value)
			.then((response)=>{
				return response;
			});
		},
		getList(value={})//获取设备天线列表数据
		{
			return Vue.prototype.axiosget("/api/rf/Antenna/getList",value)
			.then((response)=>{
				return response;
			});
		}
	};
}
